export default __webpack_public_path__ + "static/media/videocamoff.6fc2ae22.svg";